<template>
    <div>
        <b-row class="sticky-top">
            <b-col sm="12" md="6" lg="6" class="form-group bg-white py-2">
                <h4 class="p-0 mt-1 text-mary-help-purple">Novo Módulo</h4>
            </b-col>
            <b-col sm="12" md="3" lg="3" class="form-group bg-white py-2">
                <router-link class="btn btn-outline-mary-help btn-block" to="/admin/modulos"><b-icon icon="reply" flip-h class="mr-2" />Voltar</router-link>
            </b-col>
            <b-col sm="12" md="3" lg="3" class="form-group bg-white py-2">
                <b-button v-on:click="verifyForm" variant="mary-help" block><b-icon icon="cloud-arrow-up" class="mr-2" />Salvar</b-button>
            </b-col>
        </b-row>

        <b-card>
            <b-row>
                <b-col sm="12" md="12" lg="12">
                    <b-form-group id="title" label-for="title">
                        <label class="required">Título</label>
                        <b-form-input v-model="title" id="title" type="text" required placeholder="Informe um Título"></b-form-input>
                        <b-form-invalid-feedback :state="!errors.title">
                            <div v-for="error in errors.title" :key="error">
                                {{ error }}
                            </div>
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>

            <b-row>
                <b-col sm="12" md="12" lg="12">
                    <b-form-group id="training" label-for="training">
                        <label class="required">Treinamento</label>
                        <b-form-select v-model="training_id" :options="trainings"></b-form-select>
                        <b-form-invalid-feedback :state="!errors.training_id">
                            <div v-for="error in errors.training_id" :key="error">
                                {{ error }}
                            </div>
                        </b-form-invalid-feedback>
                    </b-form-group>
                </b-col>
            </b-row>
        </b-card>

        <b-card v-if="$route.params.id" class="mt-4">

            <b-row class="mb-2">
                <b-col sm="12" md="9" lg="9">
                    <h4>Arquivos</h4>
                </b-col>
                <b-col sm="12" md="3" lg="3">
                    <b-button v-on:click="AddFiles" variant="mary-help" block><b-icon icon="plus-circle" class="mr-2" />Adicionar Arquivo</b-button>
                </b-col>
            </b-row>
            <hr>
            <b-row v-for="(file, index) in files" :key="index">
                <b-col sm="12" md="5" lg="5" class="form-group">
                    <b-form-input v-model="file.title" id="title" type="text" required placeholder="Informe um Título para o Arquivo"></b-form-input>
                </b-col>
                <b-col sm="12" md="5" lg="5" class="form-group">
                    <template v-if="IsFile(file.file)">
                        <b-select class="form-group" :options="files_options" v-model="file.page"></b-select>
                        <b-form-file v-if="!file.page" v-model="file.file" placeholder="Selecione um Arquivo" drop-placeholder="Drop file here..."></b-form-file>
                    </template>
                    <a style="width: 100%" class="btn btn-outline-mary-help" v-else-if="file.file && file.file.match(/^modulo-(basico|limpeza|lavanderia)/i)" target="_blank" :href="'/treinamento/'+file.file"><b-icon icon="book" class="mr-2" /> Módulo Básico</a>
                    <b-button v-else :disabled="!file.file" type="button" class="btn btn-outline-mary-help" block @click="Download(file.file)"><b-icon icon="cloud-arrow-down" class="mr-2" /> Baixar</b-button>
                </b-col>
                <b-col sm="12" md="2" lg="2" class="form-group">
                    <b-button v-on:click="RemoveFiles(index)" variant="danger" block><b-icon icon="dash-circle" /></b-button>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import swal from 'sweetalert2'

export default {
    data() {
        return {
            trainings: []
        }
    },
    created() {
        this.LoadData();
        this.LoadTrainings();
    },
    methods: {
        IsFile(file) {
            var isfile = (file instanceof File) || file === null || file === undefined;
            return isfile;
        },
        Download(file) {
            if (!file) {
                return;
            }

            var a = document.createElement("a");
            a.target = "_blank";
            a.href = this.aws_s3_base_url +"/"+ file;
            a.click();
        },
        LoadData() {
            if (this.$route.params.id) {
                this.$store.dispatch("module/loadEditForm", this.$route.params.id);
            } else {
                this.$store.dispatch("module/loadInsertForm");
            }
        },

        LoadTrainings() {
            this.$store.dispatch('training/getAllTrainings').then(data => {
                this.trainings = data.map(function(item) {
                    return {value: item.id, text: item.title};
                });

                this.trainings.push({value: '', text: 'Selecione um Módulo'});
            });
        },

        verifyForm(){
            var module = this.$store.state.module.module;
            var error = {};
            module.title === '' ? error = {title: ['Campo Título é Obrigatório']} : null
  
            if(Object.keys(error).length === 0){
                this.addError({});
                this.Save()
            }else{
                this.addError(error);
            }
        },

        Save() {
            swal.fire({
                title: "Aguarde...",
                didOpen: () => {
                    swal.showLoading()
                }
            });
            if(!this.$route.params.id) {
                this.$store.dispatch('module/createModule').then(response => {
                    this.sweealert2('success', response.data.success)
                    this.$router.push('/admin/modulos')
                }).catch(error => {
                    this.addError(error.response)
                    this.sweealert2('error', error.response.data.error)
                });
            } else {
                this.$store.dispatch('module/updateModule').then(response => {
                    this.sweealert2('success', response.success)
                    this.$router.push('/admin/modulos')
                }).catch(error => {
                    this.addError(error.response)
                    this.sweealert2('error', error.response.error)
                });
            }
        },

        AddFiles() {
            this.files.push({title: '', page: null, file: null})
        },

        RemoveFiles(index) {
            this.files.splice(index, 1);
        },

        addError(error){
            this.$store.commit('module/SET_MODULE_ERROR', error)
        },

        sweealert2(icon, text) {
            this.$swal({
                showConfirmButton: true,
                timer: 3000,
                timerProgressBar: true,
                text: text,
                icon: icon,
                padding: 20,
            })
        }
    },
    computed: {
        files_options() {
            return [
                { text: "Módulo Básico", value: "modulo-basico" },
                { text: "Módulo de Limpeza", value: "modulo-limpeza" },
                { text: "Módulo de Lavanderia", value: "modulo-lavanderia" },
                { text: "Outro", value: null }
            ]
        },
        ...mapGetters('module', [
            'IsUpdate'
        ]),
        aws_s3_base_url: {
            get() {
                var url =this.$store.state.module.module && this.$store.state.module.module.aws_s3_base_url ? this.$store.state.module.module.aws_s3_base_url : "";
                return url;
            }
        },

        title: {
            get() {
                return this.$store.state.module.module.title;
            },
            set(value) {
                this.$store.commit('module/SET_TITLE', value)
            }
        },
        
        training_id: {
            get() {
                return this.$store.state.module.module.training_id;
            },
            set(value) {
                this.$store.commit('module/SET_TRAINING_ID', value)
            }
        },

        files: {
            get() {
                return this.$store.state.module.module.files;
            },
            set(value) {
                this.$store.commit('module/SET_FILES', value)
            }
        },

        errors: {
            get() {
                return this.$store.state.module.errors;
            },
        },
    },
}
</script>

<style lang="scss">
@import '@/assets/scss/main.scss';

.title {
    border-bottom: solid 1px $color-grey-700;

    h5 {
        color: $color-grey-700;
    }
}
</style>